// extracted by mini-css-extract-plugin
export default {"transparentBorder":"ozSWpJLte6nfX9s4kkrj"};